export default {
  // 页面标题
  'pages.tenant.package.title': '租户套餐',
  'pages.tenant.package.subtitle': '管理订阅计划和定价',

  // 搜索
  'pages.tenant.package.search.placeholder': '搜索套餐名称、套餐编码...',
  'pages.tenant.package.search': '查询',
  'pages.tenant.package.reset': '重置',

  // 状态(筛选与卡片标签)
  'pages.tenant.package.status.placeholder': '状态',
  'pages.tenant.package.status.all': '全部状态',
  'pages.tenant.package.status.enabled': '启用',
  'pages.tenant.package.status.disabled': '停用',

  // 卡片展示
  'pages.tenant.package.deviceCount': '设备数',
  'pages.tenant.package.storeCount': '店铺数',
  'pages.tenant.package.unlimited': '无限',
  'pages.tenant.package.subscriberCount': '订阅租户数',
  'pages.tenant.package.dayUnit': '天',
  'pages.tenant.package.empty': '暂无套餐数据',

  // 删除
  'pages.tenant.package.deleteConfirm': '确定删除该套餐吗？',
  'pages.tenant.package.message.deleteSuccess': '删除成功',

  // 新增
  'pages.tenant.package.addTitle': '新增套餐',
  'pages.tenant.package.add': '新增套餐',
  'pages.tenant.package.message.addSuccess': '新增成功',

  // 编辑
  'pages.tenant.package.editTitle': '编辑套餐',
  'pages.tenant.package.edit': '编辑',
  'pages.tenant.package.message.editSuccess': '编辑成功',
  'pages.tenant.package.save': '保存',
  'pages.tenant.package.cancel': '取消',

  // 分区标题
  'pages.tenant.package.divider.basicInfo': '基础信息',
  'pages.tenant.package.divider.resourceLimit': '资源限制',
  'pages.tenant.package.form.resourceLimitHint':
    '门店数或设备数填写为 0 时,表示数量不受限制。',
  'pages.tenant.package.divider.pricing': '定价信息',
  'pages.tenant.package.divider.otherSettings': '其他设置',

  // 表单
  'pages.tenant.package.form.packageName': '套餐名称',
  'pages.tenant.package.form.packageNameRequired': '请输入套餐名称',
  'pages.tenant.package.form.packageCode': '套餐编码',
  'pages.tenant.package.form.packageCodeRequired': '请输入套餐编码',
  'pages.tenant.package.form.packageCodePattern': '只允许字母、数字、下划线',
  'pages.tenant.package.form.description': '套餐描述',
  'pages.tenant.package.form.descriptionPlaceholder':
    '请简要描述套餐的特点和适用场景，帮助租户快速了解套餐优势',
  'pages.tenant.package.form.maxStores': '门店数',
  'pages.tenant.package.form.maxStoresRequired': '请输入门店数',
  'pages.tenant.package.form.maxDevices': '设备数',
  'pages.tenant.package.form.maxDevicesRequired': '请输入设备数',
  'pages.tenant.package.form.price': '套餐价值',
  'pages.tenant.package.form.priceRequired': '请输入套餐价值',
  'pages.tenant.package.form.trialDays': '使用天数',
  'pages.tenant.package.form.trialDaysPlaceholder': '请输入(天)',
  'pages.tenant.package.form.trialDaysRequired': '请输入使用天数',
  'pages.tenant.package.form.enablePackage': '启用套餐',
  'pages.tenant.package.form.switchOn': '开',
  'pages.tenant.package.form.switchOff': '关',
  'pages.tenant.package.form.disableHint': '禁用后租户将无法选择此套餐',
  'pages.tenant.package.form.sort': '排序',
  'pages.tenant.package.form.sortPlaceholderAdd': '不填默认为 0',
  'pages.tenant.package.form.sortPlaceholderEdit': '留空保持原值',
  'pages.tenant.package.form.sortTooltip':
    '数值越小越靠前;排序相同的套餐按创建时间倒序展示',
  'pages.tenant.package.form.input': '请输入',
};
